An alternate version of `summary` that includes HTML markup.

This is intended to be parsed and rendered by a web browser for displaying in a user interface.
